import { ReactNode } from "react"
import { Box, Image, VStack } from "@chakra-ui/react"

export default function StbtcSuccessScreenHeader({
  logo,
  children,
}: {
  logo?: string
  children: ReactNode
}) {
  return (
    <Box bg="primary.white.100" p={12}>
      <VStack gap={0} color="primary.black.100" textAlign="center">
        {logo && <Image src={logo} mb="30px" />}
        {children}
      </VStack>
    </Box>
  )
}
